import styled from "styled-components";

export const GameWindowBox = styled.div<{zIndex: number}>`
    display: flex;
    /* flex-direction: column; */
    position: fixed;
    padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
    z-index: ${props => props.zIndex};
    background-color: ${props => props.theme.colors.background};
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
`